<template>
	<div v-if="statistics">
		<el-row :gutter="20">
			<el-col :span="6">
				<el-statistic group-separator="," :precision="2" :value="statistics.needpayment"
					title="应付金额"></el-statistic>
			</el-col>
			<el-col :span="6">
				<el-statistic group-separator="," :value="statistics.paymentapplication" title="申请待支付">
					<template slot="formatter">
						<el-link type="primary" style="font-size: 20px;" @click="detail('paymentapplication')">{{statistics.paymentapplication.toFixed(2)}}</el-link>						
					</template>
				</el-statistic>
			</el-col>
			<el-col :span="6">
				<el-statistic group-separator="," :value="statistics.payment" title="已付金额">
					<template slot="formatter">
						<el-link type="primary" style="font-size: 20px;" @click="detail('payment')">{{statistics.payment.toFixed(2)}}</el-link>						
					</template>
				</el-statistic>
			</el-col>
			<el-col :span="6">
				<el-statistic group-separator="," :precision="2" :value="statistics.unpayment"
					title="未付金额"></el-statistic>
			</el-col>
		</el-row>

		<detail ref="staticdetail" :title="detailTitle" :data="data" />
	</div>
</template>
<style>

</style>

<script>
	import detail from './detail/index.vue'
	export default {
		name: '',
		props: {
			nodeid: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				data:[],
				detailTitle:'明细',
				statistics: {
					needpayment: 0,
					paymentapplication: 0,
					payment: 0,
					unpayment: 0
				},
			}
		},
		watch: {

		},
		mounted() {
			//this.init()
		},
		computed: {

		},
		methods: {
			init() {
				this.$api.reconciliationbill.statistics({
					nodeid: this.nodeid
				}).then((res) => {
					this.statistics = res
				})
			},
			detail(type){
				if(type=='paymentapplication'){
					this.detailTitle = '申请待支付明细'
					this.data = this.statistics.paymentapplicationList
				}
				if(type=='payment'){
					this.detailTitle = '已付金额明细'
					this.data = this.statistics.paymentList
				}
				this.$nextTick(()=>{
					this.$refs.staticdetail.modal_show()
				})
			}
		},
		components: {
			detail
		}
	}
</script>